/* eslint-disable react-hooks/exhaustive-deps */
import React, {useState, useEffect} from "react";
import { use100vh } from 'react-div-100vh'
import { isMobile } from "react-device-detect";
import Column from "./Column";
import Row from "./Row";
import { Dialog } from '@mui/material';
import Modal from "./Modal";

function Profile(props: any) {
  const {filter,hellducks,ogDucks,secondDucks,loadingHell,loadingOG,loading2nd,setHellducks,setSecondDucks,setOgDucks} = props;
  const [isOpen, setIsOpen] = useState(false);
  const [filteredhellducks, setFilteredHellducks] = useState<any>(undefined);
  const [filteredogDucks, setFilteredOgDucks] = useState<any>(undefined);
  const [selectedSecondduck, setselectedSecondduck] = useState<any>(undefined);
  const [selectedOgduck, setSelectedOgduck] = useState<any>(undefined);
  const [selectedHellduck, setSelectedHellduck] = useState<any>(undefined);
  const height = use100vh()
  const currentHeight = height ? height * 1.2 : '120vh';

  useEffect(() => {
    if (filter > 0) {
      const hellFilter = hellducks.filter((duck:any) => duck.traits.length === filter);
      const ogFilter = ogDucks.filter((duck:any) => duck.traits.length === filter);
      setFilteredHellducks(hellFilter);
      setFilteredOgDucks(ogFilter);
      setSelectedHellduck(undefined);
      setSelectedOgduck(undefined);
    }
  }, [ filter ]);

  const modalProps = {
    style: {
        borderRadius: 18,
        background: 'rgba(29, 31, 32, 0.85)',
        
    },
  };

  const handleModal = () => {
    if ((selectedSecondduck && selectedHellduck && selectedOgduck))
    {
      setIsOpen(true);
    }
  }

  return (
    <div style={{ height: isMobile ? currentHeight : 'h-5/6' }} className={`relative flex flex-col md:flex-row items-center justify-between w-full rounded-3xl content h-5/6`}>
      <Column ducks={filteredogDucks} handleSelection={setSelectedOgduck} current={selectedOgduck} loading={loadingOG}></Column>
      <div className="flex flex-col h-full justify-end items-center w-full md:w-6/12">
        <button onClick={handleModal} className={`flex ${ (selectedSecondduck && selectedHellduck && selectedOgduck) ? 'active-bg' : 'og-bg-opacity-black'} rounded-lg h-fit px-20 py-6 m-auto my-3`}>
          <div className={`m-auto leading-normal uppercase ${ (selectedSecondduck && selectedHellduck && selectedOgduck) ? 'txt-black' : 'txt-white'} text-6xl md:text-3xl`}> 
            SEND
          </div>
        </button>
        <Row ducks={secondDucks.filter((duck:any) => !duck.traits.find((element:any) => element.trait_type === 'Portal Availability'))} handleSelection={setselectedSecondduck} current={selectedSecondduck} loading={loading2nd}></Row>
      </div>
      <Column ducks={filteredhellducks} handleSelection={setSelectedHellduck} current={selectedHellduck} loading={loadingHell}></Column>
      <Dialog open={isOpen} onClose={() => setIsOpen(false)} PaperProps={modalProps} fullWidth={true}
        maxWidth={isMobile? 'xl' : 'md'}>
        <Modal
          selectedHellduck={selectedHellduck}
          selectedOgduck={selectedOgduck}
          selectedSecondduck={selectedSecondduck}
          hellducks={hellducks}
          ogDucks={ogDucks}
          secondDucks={secondDucks}
          setHellducks={setHellducks}
          setSecondDucks={setSecondDucks}
          setFilteredHellducks={setFilteredHellducks}
          setFilteredOgDucks={setFilteredOgDucks}
          filteredhellducks={filteredhellducks}
          filteredogDucks={filteredogDucks}
          setOgDucks={setOgDucks}></Modal>
      </Dialog>
    </div>
  )
}

export default Profile;